declare global {
  interface HTMLElementTagNameMap {
    "side-drawer": SideDrawer;
  }
}

class SideDrawer extends HTMLElement {
  private onKeyDown = (e: KeyboardEvent): void => {
    if (e.key !== "Escape" || !this.isOpen) return;
    const openDrawers = Array.from(
      document.querySelectorAll<SideDrawer>("side-drawer.active"),
    );
    if (openDrawers[openDrawers.length - 1] === this) {
      this.close();
    }
  };

  connectedCallback(): void {
    const overlay = this.querySelector<HTMLElement>(".side-drawer__overlay");
    overlay?.addEventListener("click", () => this.close());

    this.querySelectorAll<HTMLElement>("[data-side-drawer-close]").forEach(
      (btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          this.close();
        });
      },
    );

    document.addEventListener("keydown", this.onKeyDown);
  }

  disconnectedCallback(): void {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  open(): void {
    if (this.isOpen) return;
    this.classList.remove("closing");
    this.classList.add("active");
    document.body.style.overflow = "hidden";
    this.dispatchEvent(new CustomEvent("side-drawer:open", { bubbles: true }));
  }

  close(): void {
    if (!this.isOpen) return;
    this.classList.remove("active");
    this.classList.add("closing");
    const panel = this.querySelector<HTMLElement>(".side-drawer__panel");
    const clearClosing = (e: TransitionEvent): void => {
      if (e.propertyName !== "transform" || e.target !== panel) return;
      panel?.removeEventListener("transitionend", clearClosing);
      this.classList.remove("closing");
    };
    panel?.addEventListener("transitionend", clearClosing);
    if (!document.querySelector("side-drawer.active")) {
      document.body.style.overflow = "";
    }
    this.dispatchEvent(new CustomEvent("side-drawer:close", { bubbles: true }));
  }

  get isOpen(): boolean {
    return this.classList.contains("active");
  }
}

if (!window.customElements.get("side-drawer")) {
  window.customElements.define("side-drawer", SideDrawer);
}

export { SideDrawer };
